import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "widget" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BannerCheckMatch = _resolveComponent("BannerCheckMatch")!
  const _component_BannerFinal = _resolveComponent("BannerFinal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.calculationReady)
      ? (_openBlock(), _createBlock(_component_BannerCheckMatch, {
          key: 0,
          studyId: _ctx.studyId
        }, null, 8 /* PROPS */, ["studyId"]))
      : (_openBlock(), _createBlock(_component_BannerFinal, {
          key: 1,
          studyId: _ctx.studyId
        }, null, 8 /* PROPS */, ["studyId"]))
  ], 512 /* NEED_PATCH */))
}